import api from './api';

export default {
  getExerciseTasks({ participantExerciseId }) {
    return api.get(`/externalevents/api/v1/exercise-tasks/${participantExerciseId}/redirecturl`);
  },
};
